import { Injectable } from '@angular/core'

import { IScreenFacade, ScreenOrientationType } from '@ti/core/contracts/screen.facade'

import { withTimeout } from '../utils/with-timeout'

@Injectable()
export class BrowserScreenFacade implements IScreenFacade {
  public async currentOrientation() {
    if (screen.orientation && screen.orientation.type) {
      return screen.orientation.type?.includes('-')
        ? (screen.orientation.type.split('-')[0] as ScreenOrientationType)
        : (screen.orientation.type as ScreenOrientationType)
    }

    if (window.orientation !== undefined) {
      return Math.abs(window.orientation) === 90 ? 'landscape' : 'portrait'
    }

    return window.innerWidth > window.innerHeight ? 'landscape' : 'portrait'
  }

  public async lockOrientation(orientation: ScreenOrientationType) {
    const timeout = 128 // ms
    return withTimeout(
      (async () => {
        try {
          if ('lock' in screen.orientation && typeof screen.orientation.lock === 'function') {
            await screen.orientation.lock(orientation)
          } else if ('lockOrientation' in screen && typeof screen.lockOrientation === 'function') {
            await screen.lockOrientation(orientation)
          }
        } catch (e: unknown) {
          console.warn(`Cannot lock screen orientation`, e)
        }
      })(),
      timeout,
      `Cannot lock screen orientation within ${timeout}ms`,
    )
  }

  public async unlockOrientation() {
    const timeout = 128 // ms
    return withTimeout(
      (async () => {
        try {
          if ('unlock' in screen.orientation && typeof screen.orientation.unlock === 'function') {
            screen.orientation.unlock()
          } else if (
            'unlockOrientation' in screen &&
            typeof screen.unlockOrientation === 'function'
          ) {
            await screen.unlockOrientation()
          }
        } catch (e: unknown) {
          console.warn(`Cannot unlock screen orientation`, e)
        }
      })(),
      timeout,
      `Cannot unlock screen orientation within ${timeout}ms`,
    )
  }

  public async enterFullscreen() {
    if (document.documentElement.requestFullscreen) {
      await document.documentElement.requestFullscreen()
    }
  }

  public async exitFullscreen() {
    if (typeof document.exitFullscreen === 'function' && document.fullscreenEnabled) {
      try {
        await document.exitFullscreen()
      } catch (e) {
        console.warn(`Cannot exit fullscreen`, e)
      }
    }
  }
}
